import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import {
  Wrapper,
  Avatar,
  AvatarImg,
  About,
  Line,
  LineLink,
  ContactButton,
} from "./styles/team-member-styles";

export class TeamMember extends Component {
  state = {
    showContactActive: false,
  };

  toggleContactInfo = () => {
    this.setState(({ showContactActive }) => ({
      showContactActive: !showContactActive,
    }));
  };

  render() {
    const {
      firstName,
      lastName,
      companyName,
      location,
      yearsExperience,
      avatar,
      email,
      mobileNumber,
      linkedinUrl,
    } = this.props;
    const { showContactActive } = this.state;

    return (
      <Wrapper>
        <Avatar>
          <AvatarImg src={avatar} alt="Avatar" />
        </Avatar>
        <About>
          {showContactActive ? (
            <Fragment>
              <Line>
                <LineLink href={`mailto:${email}`} title="Email">
                  <FontAwesomeIcon icon={faEnvelope} />
                  {email}
                </LineLink>
              </Line>
              {mobileNumber && (
                <Line>
                  <LineLink href={`tel:${mobileNumber}`} title="Phone">
                    <FontAwesomeIcon icon={faPhone} />
                    {mobileNumber}
                  </LineLink>
                </Line>
              )}
              {linkedinUrl && (
                <Line>
                  <LineLink href={linkedinUrl} target="_blank" title="LinkedIn">
                    <FontAwesomeIcon icon={faLinkedin} />
                    LinkedIn
                  </LineLink>
                </Line>
              )}
            </Fragment>
          ) : (
            <Fragment>
              <Line firstName="true">
                {firstName} {lastName}
              </Line>
              <Line>{companyName}</Line>
              <Line>{location}</Line>
              <Line>{yearsExperience} years experience</Line>
            </Fragment>
          )}

          <ContactButton onClick={this.toggleContactInfo}>
            {showContactActive ? "Hide Contact" : "Show Contact"}
          </ContactButton>
        </About>
      </Wrapper>
    );
  }
}

TeamMember.propTypes = {
  email: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string,
  linkedinUrl: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  companyName: PropTypes.string,
  location: PropTypes.string.isRequired,
  yearsExperience: PropTypes.number,
  avatar: PropTypes.string,
};

TeamMember.defaultProps = {
  companyName: PropTypes.isNull,
  mobileNumber: PropTypes.isNull,
  linkedinUrl: PropTypes.isNull,
  yearsExperience: PropTypes.isNull,
  avatar: PropTypes.isNull,
};

export default TeamMember;
